import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../common/spinner/loadSpinner";
import Menucustom from "../../common/menu/menucustom";
import RicercaSanzioneService from "./ricercaSanzioneService";
import { BsFillCircleFill } from "react-icons/bs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NumberFormat from "react-number-format";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
} from "../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import moment from "moment";
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import { Alert } from "bootstrap/dist/js/bootstrap.bundle";

toast.configure();

class RicercaSanzione extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      sanzioni: [],
      sanzione: {
        numeroSanzione:"692023120164992D90071015",
        dataEmissione:1676907251000,
        importoDaPagare:5220
        },
      cercaSanzione: "",
      sanzioneTrovata: false,
      captcha:"",
      isRicercaAbilitata: false
    };
  }

  componentDidMount() {
    // console.log(this.props.location.search);
    // console.log(this.props.location.search.id)
    loadCaptchaEnginge(6);
    const params = new URLSearchParams(this.props.location.search);
    const id = params.get("id");
    // console.log(id);
    if(id!== null){
      this.setState({cercaSanzione: id});
    }

    this.ricercaSanzioneService = new RicercaSanzioneService();
    // this.ricercaSanzioneService.getSanzioni(id, this.sanzione.bind(this));
  }

  // componentDidUpdate(){
  //   if(this.state.cercaSanzione.length > 5 && validateCaptcha(this.state.captcha)){
  //     this.setState({isRicercaAbilitata:true})
  //   }else{
  //     this.setState({isRicercaAbilitata:false})
  //   }
  // }

  onChangeCercaSanzione(event) {
    this.state.cercaSanzione = event.target.value;
    this.setState({ cercaSanzione: this.state.cercaSanzione });
  }

  onChangeCaptchaInput(event){
    this.state.captcha = event.target.value;
    this.setState({captcha:this.state.captcha});
  }

  sanzione(result) {
    // console.log(result);
    this.setState({ sanzioni: result });
  }

  cercaSanzione() {
    if(validateCaptcha(this.state.captcha,true)){
        this.setState({ sanzione: "" });
    
        this.ricercaSanzioneService.searchSanzione(
          (result) => {
            this.setState({ sanzione: result });
          },
          this.state.cercaSanzione,
        );
    }else{
      alert("Captcha Errato")
    }

    // console.log(this.state.sanzione.numeroSanzione);

    if (this.state.sanzione === "") {
      this.setState({ sanzioneTrovata: true });
    } else {
      this.setState({ sanzioneTrovata: false });
    }
  }

  pagaSanzione() {
    this.ricercaSanzioneService.pagaSanzione((result) => {
      // console.log(result.data);
      if (result.status === 200) {
        window.location.href = result.data;
      }
    });
    // window.location.href = "https://www.nord-com.it/";
  }

  render() {
    const dataRilascio = new Date(this.state.sanzione.dataEmissione);
    // var data = dataRilascio.getDay(). + "/" + dataRilascio.getMonth() + "/" + dataRilascio.getFullYear() + " " + dataRilascio.getHours() + ":" + dataRilascio.getMinutes()
    var data =
      dataRilascio.toLocaleDateString("it-IT") +
      " " +
      dataRilascio.toLocaleTimeString("it-IT");

    var datas = Date(data);
    return (
      <>
        <div className="container text-center h-100">
          <div class="form-group pt-5 d-flex justify-content-center gap-3">
            <label for="">
              <b>Numero Identificativo : </b>
            </label>
            <input
              type="text"
              value={this.state.cercaSanzione}
              onChange={this.onChangeCercaSanzione.bind(this)}
            />
          </div>
          <div className="d-flex flex-column gap-4 align-items-center">
          <LoadCanvasTemplate />
          <input type="text" value={this.state.captcha} onChange={this.onChangeCaptchaInput.bind(this)}/>
          <button
            style={{ width: "30%" }}
            className="btn btn-primary"
            onClick={this.cercaSanzione.bind(this)}
            disabled={this.state.cercaSanzione.length < 5}
          >
            CERCA
          </button>
          </div>
          <br></br>
          <br></br>
          {/* MOSTRO LA SANZIONE SE C'E */}
          {this.state.sanzione === "" ? (
            <>
              <h5>Cerca la tua sanzione</h5>
              <h5>Selezionala e paga</h5>
              <br></br>
              <br></br>
            </>
          ) : (
            <>
              {" "}
              <div className="row">
                <div className="col">{""}</div>
                <div className="col text-left">
                  <div class="card" style={{ width: "35rem" }}>
                    <div class="card-body">
                      <h5 class="card-title">
                        Numero Sanzione : {this.state.sanzione.numeroSanzione}
                      </h5>
                      <br></br>
                      <h6 class="card-subtitle mb-2 text-muted">{data}</h6>
                      <br></br>
                      <br></br>
                      <div className="row">
                        <div className="col">
                          <h5>
                            {(this.state.sanzione.importoDaPagare / 100).toFixed(2)} €{" "}
                          </h5>
                        </div>
                        <br></br>
                        <div className="col">{""}</div>
                        <div className="col">
                          <br></br>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br></br>
                  <button
                    className="btn btn-primary text-center"
                    style={{ width: "100%" }}
                    onClick={this.pagaSanzione.bind(this)}
                  >
                    Paga
                  </button>
                </div>
                <div className="col">{""}</div>
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

export default RicercaSanzione;
